import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useStoryActions} from '../../../../entities';

interface UnpublishStoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  storyId: string;
  refetchStory: () => void;
}

export const UnpublishStoryModal = ({open, setOpen, storyId, refetchStory}: UnpublishStoryModalProps) => {
  const {unpublishStoryMutation} = useStoryActions();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Снятие с публикации',
    title: 'Ошибка при снятии истории с публикации',
  });

  useEffect(() => {
    if (unpublishStoryMutation.error) {
      handleError(unpublishStoryMutation.error as unknown as ApiError);
    }
  }, [unpublishStoryMutation.error, handleError]);

  const handleUnpublish = async () => {
    try {
      await unpublishStoryMutation.mutateAsync(storyId);
      refetchStory();
      setOpen(false);
    } catch (error) {
      // Ошибка будет обработана в useEffect выше
    }
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleUnpublish}
        isLoading={unpublishStoryMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Снятие с публикации'}
        textButtonApply={'Снять с публикации'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите снять эту историю с публикации?
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
